export default __webpack_public_path__ + "static/media/lixeiraMenuNovo.ab42e24c.svg";